import { ChangeEvent } from 'react';
import { NSDropdown, NSInput, NSRadioOption } from 'bricks';
import { IOptionAnyValue } from 'bricks/types';
import RenderIf from 'components/RenderIf/RenderIf';
import './CreateProjectModal.scss';

export const SITE_OPTION = {
    NEW: 'new',
    EXISTING: 'existing',
};

export interface INewProjectFormProps {
    selectedOption: string;
    onSelectOption: (option: string) => void;
    newSiteName: string;
    onNewSiteNameChange: (name: string) => void;
    selectedSite?: IOptionAnyValue;
    onSelectSite: (site: IOptionAnyValue) => void;
    projectName: string;
    onProjectNameChange: (name: string) => void;
    devSiteOptions: IOptionAnyValue[];
    hasExistingSites: boolean;
    isLoadingSites: boolean;
}

const NewProjectForm = ({
    selectedOption,
    onSelectOption,
    newSiteName,
    onNewSiteNameChange,
    selectedSite,
    onSelectSite,
    projectName,
    onProjectNameChange,
    devSiteOptions,
    hasExistingSites,
    isLoadingSites,
}: INewProjectFormProps) => (
    <div>
        <RenderIf isTrue={hasExistingSites} isLoading={isLoadingSites}>
            <>
                <div
                    className={`CreateProjectModal mb-2 cursor--pointer ${selectedOption === SITE_OPTION.NEW ? 'CreateProjectModal--selected' : ''}`}
                    onClick={() => onSelectOption(SITE_OPTION.NEW)}
                    role="presentation"
                >
                    <div className="d-flex align-items-start p-2">
                        <div className="mr-2">
                            <NSRadioOption
                                id="new-site"
                                name="site-selection"
                                label=""
                                checked={selectedOption === SITE_OPTION.NEW}
                                onChange={() => onSelectOption(SITE_OPTION.NEW)}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <div className="text-white font-weight-bold">New development site</div>
                            {selectedOption === SITE_OPTION.NEW && (
                                <div className="mt-2">
                                    <NSInput
                                        type="text"
                                        placeholder="Enter development site name"
                                        value={newSiteName}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => onNewSiteNameChange(e.target.value)}
                                        name="newSiteName"
                                        required
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div
                    className={`CreateProjectModal mb-2 cursor--pointer ${selectedOption === SITE_OPTION.EXISTING ? 'CreateProjectModal--selected' : ''}`}
                    onClick={() => onSelectOption(SITE_OPTION.EXISTING)}
                    role="presentation"
                >
                    <div className="d-flex align-items-start p-2">
                        <div className="mr-2">
                            <NSRadioOption
                                id="existing-site"
                                name="site-selection"
                                label=""
                                checked={selectedOption === SITE_OPTION.EXISTING}
                                onChange={() => onSelectOption(SITE_OPTION.EXISTING)}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <div className="text-white font-weight-bold">Existing development site</div>
                            {selectedOption === SITE_OPTION.EXISTING && (
                                <div className="mt-2">
                                    <NSDropdown
                                        options={devSiteOptions}
                                        selectedOption={selectedSite}
                                        handleSelectOption={onSelectSite}
                                        placeholder={isLoadingSites ? 'Loading development sites...' : 'Select existing development site'}
                                        isFullWidth
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </>
        </RenderIf>

        <RenderIf isTrue={!hasExistingSites} isLoading={isLoadingSites}>
            <div className="mb-2">
                <NSInput
                    label="Development site name"
                    type="text"
                    placeholder="Enter development site name"
                    value={newSiteName}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => onNewSiteNameChange(e.target.value)}
                    name="newSiteName"
                    required
                />
                <div className="font-12">Once created, this development site can contain any future projects you create.</div>
            </div>
        </RenderIf>
        <div>
            <NSInput
                label="Project name"
                type="text"
                placeholder="Enter project name"
                value={projectName}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onProjectNameChange(e.target.value)}
                name="projectName"
                required
            />
        </div>
    </div>
);

export default NewProjectForm;
